export default "__VITE_ASSET__e5827c08__"